import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, login, logout } from './features/userSlice';
import { auth } from './firebase';

import Auth from './components/Auth';
import Management from './Management';

import ErrorScreen from './components/ErrorScreen';

// xross utils
import { getXrossUserProfile } from './common/firebase/user';

// 任意: メールドメインでの事前フィルタも使いたい場合
const ALLOW_DOMAIN = 'piyamaru.com'; // ここを適宜変更
// const ALLOW_DOMAIN = 'gmail.com'; // ここを適宜変更

const App: React.FC = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  // 追加：認可状態の判定用
  const [checking, setChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // userの状態を監視する
    const unSub = auth.onAuthStateChanged((authUser) => {
      (async () => {
        try {
          if (authUser) {
            // XROSS_USER 情報を取得する
            const xrossUser = await getXrossUserProfile(authUser.uid);

            // Redux にログイン情報反映（従来通り）
            dispatch(
              login({
                uid: authUser.uid,
                photoUrl: xrossUser?.xrossAvatarURL || '',
                displayName: xrossUser?.xrossUserName || '',
                email: xrossUser?.email || authUser.email || '',
              })
            );

            // 追加：カスタムクレーム（admin）で認可チェック

            const isAdmin = xrossUser?.isAdmin || false; // xrossUserから管理者フラグを取得

            // 任意：メールドメインでも足切りしたい場合は併用
            const email = authUser.email || xrossUser?.email || '';
            const inCorp = email.endsWith(`@${ALLOW_DOMAIN}`);

            // ここで最終判定を定義（必要に応じて条件を調整）
            const allowed = isAdmin && inCorp;

            setIsAuthorized(allowed);
            setChecking(false);
            console.log('Authorization status:', allowed);

            if (!allowed) {
              // 認可外は即ログアウトして画面も閉じる
              await auth.signOut();
              dispatch(logout());
              setError('管理者権限がないためアクセスできません。');
              setIsAuthorized(false);
              setChecking(false);
              return;
            }
          } else {
            // 未ログイン
            dispatch(logout());
            setIsAuthorized(false);
            setChecking(false);
          }
        } catch (e) {
          // 万一のエラー時は安全側：ログアウト
          await auth.signOut();
          dispatch(logout());
          setIsAuthorized(false);
          setChecking(false);
        }
      })();
    });

    // cleanup処理
    return () => {
      unSub();
    };
  }, [dispatch]);

  // 判定中はローディング
  if (checking) {
    return (
      <div
        style={{
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        認証を確認しています…
      </div>
    );
  }

  if (error) {
    return <ErrorScreen message={error} />;
  }

  // 認可された管理者のみ Management を表示
  return (
    <>
      {user.uid && isAuthorized ? (
        <div>
          <Management />
        </div>
      ) : (
        // 未ログイン or 認可外 → Auth（ただしサインアップは Auth 側で隠す想定）
        <Auth />
      )}
    </>
  );
};

export default App;

// import React, { useEffect } from 'react';
// //import styles from "./App.module.css";
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, login, logout } from './features/userSlice';
// import { auth } from './firebase';

// import Auth from './components/Auth';
// import Management from './Management';

// // xross utils
// import { setXrossUSerProfile } from './adminUtil/adminXrossUtil';
// import { getXrossUserProfile } from './common/firebase/user';

// //
// // xross.club Moon 運営管理サーバ
// // 2021-11-13
// const App: React.FC = () => {
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     // userの状態を監視する
//     const unSub = auth.onAuthStateChanged((authUser) => {
//       if (authUser) {
//         // util : xrossUSerProfile Setting
//         // ログイン成功時にxrossUserProfile を更新する
//         // const currentUser = auth.currentUser;
//         // if (currentUser) {
//         //   setXrossUSerProfile(currentUser);
//         //   //updateUser(authUser.uid, initialUser);
//         // }

//         // XROSS_USER 情報を取得する
//         (async () => {
//           const xrossUser = await getXrossUserProfile(authUser.uid);
//           dispatch(
//             login({
//               uid: authUser.uid,
//               photoUrl: xrossUser?.xrossAvatarURL,
//               displayName: xrossUser?.xrossUserName,
//               email: xrossUser?.email,
//             })
//           );
//         })();
//       } else {
//         dispatch(logout());
//       }
//     });
//     // cleanup処理
//     return () => {
//       unSub();
//     };
//   }, [dispatch]); //useEffectの第２引数に dispatch を指定
//   return (
//     <>
//       {user.uid ? (
//         // userが存在するとき 管理画面コンポーネントが呼び出される
//         <div>
//           <Management />
//         </div>
//       ) : (
//         // userが存在しないとき Authコンポーネントが呼び出される
//         <Auth />
//       )}
//     </>
//   );
// };

// export default App;
